import { useState } from "react";
import "../styles/Settings.css";

const Settings = () => {
  const [systemSettings, setSystemSettings] = useState({
    systemName: "Auraplan Digital Portal",
    logo: null,
    emailSender: "no-reply@auraplan.com",
  });
  const [securitySettings, setSecuritySettings] = useState({
    apiKey: "xxxx-xxxx-xxxx-xxxx",
    enable2FA: false,
    passwordPolicy: "Minimum 8 characters, 1 uppercase, 1 number",
  });
  const [emailTemplate, setEmailTemplate] = useState(
    "Subject: Ihr Zertifikat\n\nHallo {recipient},\n\nIhr Zertifikat ist beigefügt.\n\nMit freundlichen Grüßen,\nAuraplan Team"
  );
  const [status, setStatus] = useState("");

  const handleSystemSettingsChange = (field, value) => {
    setSystemSettings({ ...systemSettings, [field]: value });
  };

  const handleLogoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSystemSettings({ ...systemSettings, logo: file });
      setStatus(`Logo ${file.name} ausgewählt (Platzhalter).`);
    }
  };

  const handleSecuritySettingsChange = (field, value) => {
    setSecuritySettings({ ...securitySettings, [field]: value });
  };

  const handleGenerateApiKey = () => {
    const newApiKey = "xxxx-xxxx-xxxx-xxxx"; // Placeholder for API key generation
    setSecuritySettings({ ...securitySettings, apiKey: newApiKey });
    setStatus("Neuer API-Schlüssel generiert (Platzhalter).");
  };

  const handleSaveSettings = () => {
    setStatus("Einstellungen gespeichert (Platzhalter).");
    // In a real implementation, this would save settings via an API
  };

  const handleBackup = () => {
    setStatus("Backup erstellt (Platzhalter).");
    // In a real implementation, this would trigger a backup process
  };

  const handleRestore = (e) => {
    const file = e.target.files[0];
    if (file) {
      setStatus(`Backup ${file.name} wiederhergestellt (Platzhalter).`);
      // In a real implementation, this would restore data from the file
    }
  };

  return (
    <div className="settings-container">
      <header className="settings-header">
        <h1>Einstellungen</h1>
      </header>
      <main className="settings-main">
        {/* General Settings */}
        <section className="settings-section">
          <h2>Allgemein</h2>
          <div className="form-group">
            <label>Systemname</label>
            <input
              type="text"
              value={systemSettings.systemName}
              onChange={(e) => handleSystemSettingsChange("systemName", e.target.value)}
            />
          </div>
          <div className="form-group">
            <label>Logo</label>
            <input type="file" accept="image/*" onChange={handleLogoChange} />
            {systemSettings.logo && (
              <p>Ausgewählt: {systemSettings.logo.name}</p>
            )}
          </div>
          <div className="form-group">
            <label>E-Mail-Absender</label>
            <input
              type="email"
              value={systemSettings.emailSender}
              onChange={(e) => handleSystemSettingsChange("emailSender", e.target.value)}
            />
          </div>
        </section>

        {/* Security Settings */}
        <section className="settings-section">
          <h2>Sicherheit</h2>
          <div className="form-group">
            <label>API-Schlüssel</label>
            <div className="api-key-group">
              <input type="text" value={securitySettings.apiKey} readOnly />
              <button onClick={handleGenerateApiKey}>Neu generieren</button>
            </div>
          </div>
          <div className="form-group">
            <label>Zwei-Faktor-Authentifizierung (2FA)</label>
            <label className="toggle-switch">
              <input
                type="checkbox"
                checked={securitySettings.enable2FA}
                onChange={(e) => handleSecuritySettingsChange("enable2FA", e.target.checked)}
              />
              <span className="slider"></span>
            </label>
          </div>
          <div className="form-group">
            <label>Passwortrichtlinie</label>
            <input
              type="text"
              value={securitySettings.passwordPolicy}
              onChange={(e) => handleSecuritySettingsChange("passwordPolicy", e.target.value)}
            />
          </div>
        </section>

        {/* Email Templates */}
        <section className="settings-section">
          <h2>E-Mail-Vorlagen</h2>
          <div className="form-group">
            <label>E-Mail-Inhalt für Zertifikatversand</label>
            <textarea
              value={emailTemplate}
              onChange={(e) => setEmailTemplate(e.target.value)}
              rows="6"
            />
          </div>
        </section>

        {/* Backup/Restore */}
        <section className="settings-section">
          <h2>Backup/Wiederherstellung</h2>
          <div className="backup-actions">
            <button onClick={handleBackup}>Backup erstellen</button>
            <label className="restore-btn">
              Backup wiederherstellen
              <input
                type="file"
                accept=".zip,.bak"
                onChange={handleRestore}
                style={{ display: "none" }}
              />
            </label>
          </div>
        </section>

        {/* Save Button */}
        <section className="settings-actions">
          <button onClick={handleSaveSettings}>Einstellungen speichern</button>
          {status && <p className="status-message">{status}</p>}
        </section>
      </main>
    </div>
  );
};

export default Settings;